import React from 'react';
import PropTypes from 'prop-types';
import Icon from '@hobs/components/Icon';
import { USER_ROLES } from '@hobs/utils/constants';
import WithRoles from '@hobs/hocs/WithRoles';
import { withRouter } from 'react-router';
import { Link } from 'react-router-dom';
import Confirm from '@hobs/components/Confirm';
import { withTranslation } from 'react-i18next';
import Discussion from '@hobs/containers/Discussion';

import './HeadingActions.scss';

class HeadingActions extends React.PureComponent {
  isActive(path) {
    return path === this.props.location.pathname;
  }

  navigateTo(path) {
    if (this.props.isDirty) {
      Confirm(
        this.props.t('Cancel service request'),
        this.props.t(
          'Are you sure you want to cancel? All entered data will be lost.'
        ),
        () => {
          this.props.history.push(path);
        }
      );
    } else {
      this.props.history.push(path);
    }
  }

  render() {
    const { hasUserPermission, discussionPath } = this.props;
    return (
      <div className="heading-actions">
        {this.props.showPath && (
          <Link
            className={
              this.isActive(this.props.showPath)
                ? 'heading-actions--active'
                : ''
            }
            to={this.props.showPath}
            onClick={e => {
              e.preventDefault();
              this.navigateTo(this.props.showPath);
            }}
          >
            <Icon icon="Info" />
          </Link>
        )}
        {this.props.editPath && (
          <Link
            className={
              this.isActive(this.props.editPath)
                ? 'heading-actions--active'
                : ''
            }
            to={this.props.editPath}
          >
            <Icon icon="Pen" />
          </Link>
        )}
        {this.props.historyPath && (
          <Link
            className={
              this.isActive(this.props.historyPath)
                ? 'heading-actions--active'
                : ''
            }
            to={this.props.historyPath}
            onClick={e => {
              e.preventDefault();
              this.navigateTo(this.props.historyPath);
            }}
          >
            <Icon icon="History" />
          </Link>
        )}
        {this.props.discussion && !hasUserPermission(USER_ROLES.READONLY) && (
          <Link to={discussionPath}>
            <Discussion {...this.props.discussion} />
          </Link>
        )}
      </div>
    );
  }
}

HeadingActions.propTypes = {
  onNavigate: PropTypes.func,
  showPath: PropTypes.string,
  editPath: PropTypes.string,
  isDirty: PropTypes.bool,
  historyPath: PropTypes.string,
  history: PropTypes.object,
  t: PropTypes.func,
  discussion: PropTypes.shape({
    serviceRequestId: PropTypes.string,
    status: PropTypes.number,
    initials: PropTypes.string,
    iconOnly: PropTypes.bool
  }),
  location: PropTypes.shape({
    pathname: PropTypes.string
  }),
  hasUserPermission: PropTypes.func,
  discussionPath: PropTypes.string
};

export default withTranslation()(withRouter(WithRoles(HeadingActions)));
